<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-2">
          <vs-button
            @click="createTag()"
            class="bg_l_green"
            v-has-permission="permission263"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewTag") }}
          </vs-button>
        </div>
      </div>
      <modify-popup
        :show="ModifyPopup"
        :model="modalModel"
        @finish="onfinish"
        @close="closeModifyPopup"
      ></modify-popup>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Name'), sort: 'Name' },
              { title: $t('CreateOn'), sort: 'CreateOn' },
              { title: $t('IsActive') },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 24%">
                {{ row.name }}
              </td>
              <td style="width: 24%; direction: ltr">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 24%">
                <vs-checkbox v-model="row.isActive" :disabled="true">{{
                  $t("Active")
                }}</vs-checkbox>
              </td>
              <td style="width: 24%">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click.prevent="editTag(row)"
                  class="ml-4 d-inline"
                  v-has-permission="permission261"
                ></vs-button>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deleteTag(row.id)"
                  class="d-inline"
                  v-has-permission="permission262"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
export default {
  name: "Content-management-Tags-Index",
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission261: "ModifyTag",
      permission262: "DeleteTag",
      permission263: "CreateTag",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "CMS/api/TagsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeTag: "tag/remove",
    }),
    createTag() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    editTag(model) {
      this.modalModel = {
        id: model.id,
        name: model.name,
        isActive: model.isActive,
        isImportant: model.isImportant,
      };
      this.ModifyPopup = true;
    },
    deleteTag(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeTag(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
